import { render, staticRenderFns } from "./TermsAndConditionsBanner.vue?vue&type=template&id=20458a40&"
import script from "./TermsAndConditionsBanner.vue?vue&type=script&lang=ts&"
export * from "./TermsAndConditionsBanner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports